import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { LandingPageLP1 } from './pages/LandingPageLP1';
import { LandingPageLP3 } from './pages/LandingPageLP3';
import { LandingPageLP4 } from './pages/LandingPageLP4';
import { LandingPageV2 } from './pages/LandingPageV2';
import { CheckoutPage } from './pages/CheckoutPage';
import { Modulo0Page } from './pages/Modulo0Page';
import { AccessPage } from './pages/AccessPage';
import { Modulo2Page } from './pages/Modulo2Page';
import { Modulo3Page } from './pages/Modulo3Page';
import { Modulo4Page } from './pages/Modulo4Page';
import { SignupPage } from './pages/SignupPage';
import { LoginPage } from './pages/LoginPage';
import { CalculadoraPage } from './pages/CalculadoraPage';
const PIXEL_ID = '1626906698580220';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
function initFacebookPixel() {
  if (window.fbq) return;
  const f = window;
  const b = document;
  const n = 'script';
  let e: any;
  const t = function (this: any) {
    // eslint-disable-next-line prefer-rest-params
    t.callMethod ? t.callMethod.apply(t, arguments) : t.queue.push(arguments);
  } as any;
  if (!f.fbq) f.fbq = t;
  t.push = t;
  t.loaded = true;
  t.version = '2.0';
  t.queue = [] as any[];
  e = b.createElement(n);
  e.async = true;
  e.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = b.getElementsByTagName(n)[0];
  s?.parentNode?.insertBefore(e, s);
  window.fbq('init', PIXEL_ID);
}
function PixelTracker() {
  const location = useLocation();
  const path = location.pathname;
  useEffect(() => {
    initFacebookPixel();
    // PageView on every page
    window.fbq('track', 'PageView');
    // ViewContent on every page
    window.fbq('track', 'ViewContent', {
      content_name: `AI Web Closer - ${path || '/'}`
    });
    // AddToCart on checkout page
    if (path === '/checkout') {
      window.fbq('track', 'AddToCart', {
        content_name: 'AI Web Closer Course',
        content_type: 'product',
        value: 27,
        currency: 'USD'
      });
    }
  }, [path]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0">
      <PixelTracker data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<LandingPage data-id="element-4" />} data-id="element-3" />
        <Route path="/lp1" element={<LandingPageLP1 data-id="element-6" />} data-id="element-5" />
        <Route path="/lp2" element={<LandingPageV2 data-id="element-8" />} data-id="element-7" />
        <Route path="/lp3" element={<LandingPageLP3 data-id="element-10" />} data-id="element-9" />
        <Route path="/lp4" element={<LandingPageLP4 data-id="element-12" />} data-id="element-11" />
        <Route path="/checkout" element={<CheckoutPage data-id="element-14" />} data-id="element-13" />
        <Route path="/calculadora" element={<CalculadoraPage data-id="element-16" />} data-id="element-15" />
        <Route path="/member-signup" element={<SignupPage data-id="element-18" />} data-id="element-17" />
        <Route path="/login" element={<LoginPage data-id="element-20" />} data-id="element-19" />
        <Route path="/modulo-0" element={<Modulo0Page data-id="element-22" />} data-id="element-21" />
        <Route path="/modulo-1" element={<AccessPage data-id="element-24" />} data-id="element-23" />
        <Route path="/modulo-2" element={<Modulo2Page data-id="element-26" />} data-id="element-25" />
        <Route path="/modulo-3" element={<Modulo3Page data-id="element-28" />} data-id="element-27" />
        <Route path="/modulo-4" element={<Modulo4Page data-id="element-30" />} data-id="element-29" />
      </Routes>
    </BrowserRouter>;
}